<template>
	<table class="table sheet-balance">
		<thead>
			<tr>
				<th></th>
				<th v-i18n="'sheet_total'"></th>
				<th v-i18n="'sheet_balance'"></th>
			</tr>
		</thead>
		<tbody>
			<tr v-for="item of items" :key="item.booker.id">
				<th class="text-nowrap" :title="item.booker.name">{{item.booker.name}}</th>
				<td class="text-right text-nowrap">{{item.balance[0] | format-currency(currency)}}</td>
				<td class="text-right text-nowrap"
				    :class="{'number-positive': item.balance[1]>0, 'number-negative': item.balance[1]<0}"
				>{{item.balance[1] | format-currency(currency)}}</td>
			</tr>
		</tbody>
		<tfoot>
			<tr>
				<th v-i18n="'sheet_total'"></th>
				<td class="text-right text-nowrap">{{total | format-currency(currency)}}</td>
				<td class="text-right text-nowrap">{{totalBalance | format-currency(currency)}}</td>
			</tr>
		</tfoot>
	</table>
</template>
<script>
	import store from "../core/store";

	class Item {
		constructor(booker, balance) {
			this.booker = booker;
			this.balance = balance;
		}
	}

	function createItems(balance, sheetKey) {
		let items;
		if (balance) {
			items = balance.map(bookerBalance => {
				return new Item(store.get(sheetKey.parent, 'Booker', bookerBalance.id), bookerBalance.value);
			})
		} else {
			items = store.getByParent(sheetKey, 'Sheeter').map(sheeter => new Item(sheeter.booker, {value: [0, 0]}));
		}
		items.sort((a, b) => a.booker.name.localeCompare(b.booker.name));
		return items;
	}

	function itemsSum(items, index) {
		return items.reduce((total, item) => {
			total += item.balance[index];
			return total;
		}, 0);
	}

	export default {
		props: {
			sheetKey: Object,
			balance: Array,
			currency: String
		},

		data() {
			return {
				items: createItems(this.balance, this.sheetKey)
			};
		},

		computed: {
			total() {
				return itemsSum(this.items, 0);
			},
			totalBalance() {
				return itemsSum(this.items, 1);
			}
		},

		filters: {
			round(value) {
				return value.toFixed(2);
			}
		},

		watch: {
			'balance': function () {
				this.items = createItems(this.balance, this.sheetKey)
			}
		}
	}
</script>

<style lang="scss">
	.sheet-balance {
		thead tr:first-child th {
			border-top: none;
		}
		tr th:first-child {
			overflow: hidden;
			text-overflow: ellipsis;
			padding-right: 0;
		}
		tr td {
			padding-left: 0;
		}
	    tfoot tr>* {
		    border-top-style: double;
		    border-top-width: 7px;
	    }
	}
</style>


// WEBPACK FOOTER //
// src/ui/sheet-balance.vue